export default 'M21 9.59A14.5 14.5 0 0 1 12 23 14.5 14.5 0 0 1 3 9.59V3c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2z';